import { render, staticRenderFns } from "./TraceyAiV1Turn.vue?vue&type=template&id=772bf567"
import script from "./TraceyAiV1Turn.vue?vue&type=script&lang=js"
export * from "./TraceyAiV1Turn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports